import { PackageContentBlockInDetail } from './package-content-block-in-detail.component'

export default {
  PackageContentBlockInDetail,
}
